export { default } from './TotalSupplyIcon';



// WEBPACK FOOTER //
// ./src/icons/TotalSupplyIcon/index.js